/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />

var BusinessSimulationServerInterface = null;

class BusinessSimulation extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		//variables for placeholder replacement
		this.itemId = "PLH_itemId";

		this.itemIsOnSale = "PLH_isOnSale";
		this.machine = "PLH_machine";
		this.gold = "PLH_gold";
		this.goldTag = "PLH_goldTag";
		this.rangeStart = "PLH_rangeStart";
		this.amountToLoad = "PLH_amountToLoad";
		this.objectCategory = "PLH_ObjectCategory";
		BusinessSimulationServerInterface = this;
	}

	redirectToAdvertising() {
		window.location.href = this.options.advertisingUrl;
	}

	setItemOnSale(itemId) {
		axios(new UrlTemplate(this.options.salesUrl)
		.r(this.itemId, parseInt(itemId))
		.r(this.itemIsOnSale, true)
		.url, {
			method: 'get'
		});
	}

	setItemOffSale(itemId) {
		axios(new UrlTemplate(this.options.salesUrl)
		.r(this.itemId, parseInt(itemId))
		.r(this.itemIsOnSale, false)
		.url, {
			method: 'get'
		});
	}

	buyMachine(itemId, machine) {
		axios(new UrlTemplate(this.options.machineUrl)
		.r(this.itemId, parseInt(itemId))
		.r(this.machine, parseInt(machine))
		.url, {
			method: 'get'
		});
	}

	callForMoneyTransaction(amount, tag) {
		axios(new UrlTemplate(this.options.callForMoneyTransactionUrl)
		.r(this.gold, amount)
		.r(this.goldTag, tag)
		.url, {
			method: 'get'
		});
	}

	checkForGold(amount, onTrueCallback, onFalseCallback) {
		axios(new UrlTemplate(this.options.checkGoldUrl)
		.r(this.gold, amount)
		.url, {
			method: 'get'
		}).then((response) => {
			var parsedResponse = response.data;

			if (parsedResponse.success) {
				onTrueCallback();
			} else {
				onFalseCallback();
			}
		});
	}

	loadItems(category, onTrueCallback) {
		axios(new UrlTemplate(this.options.loadItemsUrl)
		.r(this.objectCategory, category)
		.url, {
			method: 'get'
		}).then((response) => {
			onTrueCallback(response.data.items);
		});
	}

	loadItemGraphInformation(itemId, onTrueCallback) {
		axios(new UrlTemplate(this.options.loadItemInfoUrl)
		.r(this.itemId, itemId)
		.url, {
			method: 'get'
		}).then((response) => {
			onTrueCallback(response.data.stats);
		});
	}
}
